
<ul class="cursor" id="cursor">
    <div *ngFor="let data of cursorLine" [class]="data.flex">
        <li>
            <div [class]="data.class">
                <div class="tooltip" *ngIf="data.info">
                    <div *ngFor="let cursor of data.info">
                        <h4>{{cursor.label}}</h4>
                        <time class="date">{{ cursor.date }}</time>
                    </div>
                </div>
            </div>
        </li>
    </div>


</ul>
<ul class="timeline" id="timeline">
    <div *ngFor="let data of timeLineData" [class]="data.class.flex">
        <li [class]="data.class.style">
            <div [class]="data.class.alignment" (click)="switchDisplay(data)">
                <div *ngIf="!data.displayInfo; else info" >
                    <p> {{data.label}} </p>
                    <h4 class="date">{{ data.displayDate }}</h4>
                </div>
                <ng-template #info >
                    <div class="info">
                        <p> {{data.label}} </p>
                        <h4> {{data.remaining}} {{wording.remainingDays}}</h4>
                    </div>
                </ng-template>

            </div>
        </li>
    </div>


</ul>
